import { Loader } from "@mantine/core";
// import PreviewHeader from "components/header/PreviewHeader";
import AdminSupplierOrderPreview from "pages/admin/suppliers/AdminSupplierOrderPreview";
import { useSearchParams } from "react-router-dom";

type PreviewType = "altCode" | "noAltCode" | "summary";

const PrintSupplierOrderAlt: React.FC = () => {
  const [params] = useSearchParams();
  const id = params.get("id");
  const raw = params.get("t");

  const previewType =
    raw === "altCode" || raw === "noAltCode" || raw === "summary"
      ? raw
      : "summary";

  if (!id) return <Loader />;

  return (
    <div className="inner-container">
      {/* <PreviewHeader /> */}
      <AdminSupplierOrderPreview
        previewType={previewType}
        recordId={Number(id)}
      />
    </div>
  );
};

export default PrintSupplierOrderAlt;
